/*Originals Logic*/

/*Collection Page - update label, hide filter, hide quick shop*/

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("p.label__text").forEach(function(el) {
    if (el.textContent.trim() === "Sold Out") {
      el.textContent = "Sold";
    }
  });

  document.querySelectorAll(".quick-shop__trigger").forEach(function(el) {
    el.style.display = "none";
  });

  document.querySelectorAll(".collection-main__filter").forEach(function(el) {
    el.style.display = "none";
  });
});

/*Product Page hide all unnecessary elements*/
document.addEventListener("DOMContentLoaded", function() {
  if (document.querySelector(".template-product")) {
    var label = document.querySelector(".label--sold_out");
    var isSoldOut = label && !label.hasAttribute("hidden");

    if (isSoldOut) {
      [".price__text", ".product-single__box__block--inventory_notice", ".product-single__box__block--buy_buttons", ".product-single__box__block--quantity_selector", ".js-section__product-recommendations"].forEach(function(selector) {
        document.querySelectorAll(selector).forEach(function(el) {
          el.style.display = "none";
        });
      });

      var description = document.querySelector(".product-single__box__block--description");
      var spacer = document.querySelector(".product-single__box__block--spacer");
      if (description && spacer) {
        var content = description.innerHTML;
        description.style.display = "none";
        var newEl = document.createElement("div");
        newEl.innerHTML = content;
        spacer.insertAdjacentElement("afterend", newEl);
      }
    }
  }
});


/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map
